<template>
  <el-footer height="29px" class="m_footer">{{ cpString }}</el-footer>
</template>

<script>
export default {
  props: {
    cpString: String
  }
};
</script>

<style scoped lang="less">
.m_footer {
  position: fixed;
  width: 100vw;
  bottom: 0;
  line-height: 30px;
  left: 0;
  font-size: 12px;
  color: #9b9b9b;
  text-align: center;
  line-height: 30px;
  background: none;
}
</style>
